import { component } from 'picoapp'
import { zelektor } from '@/lib/utility-functions.js'
import { formatMoney } from '@/lib/currency.js'


export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { minInput, maxInput, minRange, maxRange, fill, mainInput } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Event Listeners
    /*******************************************************************************************************************************************/
    ctx.on('filter:loaded', ({filter}) => {
        minInput.addEventListener('input', writeInput)
        maxInput.addEventListener('input', writeInput)
        minInput.addEventListener('change', changeInput)
        maxInput.addEventListener('change', changeInput)

        minRange.addEventListener('input', inputMinRange)
        maxRange.addEventListener('input', inputMaxRange)
        minRange.addEventListener('change', changeMinRange)
        maxRange.addEventListener('change', changeMaxRange)
    })

    ctx.on('filter:loaded', ({filter}) => {
        initValues(filter.prices)
        inputMinRange()
        inputMaxRange()
    })

    ctx.on('filter:clear', () => {
        clear()
    })


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function initValues(prices) {
        const min = parseInt(prices.min)
        const max = parseInt(prices.max)

        minInput.placeholder = formatMoney(min * 100)
        maxInput.placeholder = formatMoney(max * 100)

        minRange.min = min
        minRange.max = max
        minRange.value = min
        
        maxRange.min = min
        maxRange.max = max
        maxRange.value = max

        const inputEvent = new Event('input')
        maxRange.dispatchEvent(inputEvent)
        minRange.dispatchEvent(inputEvent)
    }
    
    function writeInput(e) {
        const thisInput = e.currentTarget
        const { value } = thisInput
        const { data } = e
        const regex = new RegExp('^[0-9]+$')
        
        if (data && !data.match(regex))
            thisInput.value = value.slice(0, value.length - 1)
    }

    function changeInput(e) {
        const thisInput = e.currentTarget
        let { value } = thisInput
        
        const inputEvent = new Event('input')
        const changeEvent = new Event('change')

        if (thisInput === minInput) {
            value = Math.min(parseInt(value), parseInt(maxRange.value) - 1)
            const minVal = parseInt(minRange.min)
            if (value < minVal) value = minVal
            minRange.value = value
            minRange.dispatchEvent(inputEvent)
            minRange.dispatchEvent(changeEvent)
        }

        if (thisInput === maxInput) {
            value = Math.max(parseInt(value), parseInt(minRange.value) + 1)
            const maxVal = parseInt(maxRange.max)
            if (value > maxVal) value = maxVal
            maxRange.value = value
            maxRange.dispatchEvent(inputEvent)
            maxRange.dispatchEvent(changeEvent)
        }

        thisInput.value = ''
        thisInput.placeholder = formatMoney(value*100)
    }
    
    function inputMinRange() {
        const { min, max } = minRange

        const value = Math.min(parseInt(minRange.value), parseInt(maxRange.value) - 1)
        minRange.value = value

        const percent = ((value - min) / (max - min)) * 100
        fill.style.left = `${percent}%`

        minInput.placeholder = formatMoney(parseInt(value) * 100)
    }

    function inputMaxRange() {
        const { min, max } = maxRange

        const value = Math.max(parseInt(maxRange.value), parseInt(minRange.value) + 1)
        maxRange.value = value

        const percent = ((value - min) / (max - min)) * 100
        fill.style.right = `${100 - percent}%`

        maxInput.placeholder = formatMoney(parseInt(value) * 100)
    }

    function changeMinRange(e) {
        const value = e.currentTarget.value
        update(value, 'min')
    }

    function changeMaxRange(e) {
        const value = e.currentTarget.value
        update(value, 'max')
    }

    function update(value, minMax) {
        mainInput.dataset[minMax] = value

        const e = new Event('change')
        mainInput.dispatchEvent(e)
    }

    function clear() {
        minRange.value = minRange.min
        maxRange.value = maxRange.max

        const inputEvent = new Event('input')
        minRange.dispatchEvent(inputEvent)
        maxRange.dispatchEvent(inputEvent)
        
        const changeEvent = new Event('change')
        minRange.dispatchEvent(changeEvent)
        maxRange.dispatchEvent(changeEvent)

    }
})